import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Card, Select, message, Tabs, Input, Modal } from "antd";
import { req_edit_usm_space, req_single_people } from "../../api";
import SpaceManagementManagerModal from "./space-management-manager-modal";
const { TextArea } = Input;
class SpaceManagementModalEdit extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  static propTypes = {
    space: PropTypes.object,
  };

  state = {
    item: {
      Uid: "",
      BuildingName: "NONE",
      SpaceCode: "",
      SpaceStandardTwName: "",
      SpaceStandardEnName: "",
      DepartmentCode: "NONE",
      AgentCode: "NONE",
      CustodianCode: "",
      CustodianTwName: "待定",
      TwPingSize: "0",
      SquareMeter: "0",
      Accommodate: "0",
      UseType: "USE00",
      TvedbUseType: "TVB00",
      Monitoring: "Y",
      floor: "0",
      ApplyPhysicalPlate: "N",
    },
    buildings: [
      { text: "美術系館", value: "美術系館" },
      { text: "商學大樓", value: "商學大樓" },
      { text: "中正大樓", value: "中正大樓" },
      { text: "中央文創工廠", value: "中央文創工廠" },
      { text: "設計大樓", value: "設計大樓" },
      { text: "教育大樓", value: "教育大樓" },
      { text: "服設館", value: "服設館" },
      { text: "家政館", value: "家政館" },
      { text: "幼教大樓", value: "幼教大樓" },
      { text: "圖書資訊大樓", value: "圖書資訊大樓" },
      { text: "生活科技大樓", value: "生活科技大樓" },
      { text: "音樂館", value: "音樂館" },
      { text: "多功能展演中心", value: "多功能展演中心" },
      { text: "乃建堂", value: "乃建堂" },
      { text: "臨時教室", value: "臨時教室" },
      { text: "學生活動中心", value: "學生活動中心" },
      { text: "教學大樓", value: "教學大樓" },
      { text: "育樂館", value: "育樂館" },
      { text: "集賢盧", value: "集賢盧" },
      { text: "馨如樓", value: "馨如樓" },
      { text: "體育室", value: "體育室" },
      { text: "貨櫃屋", value: "貨櫃屋" },
    ],
    CustodianTwName: "待定",
    isLocked: true,
    isShowModal: false,
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.init();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_edit_item = async (item) => {
    const { token } = this.props.user;
    this.setState({ loading: true });
    const result = await req_edit_usm_space(item, token);
    this.setState({ loading: false });
    //console.log(result);
    if (result.status === "success") {
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 有ID
  api_single_item = async (id) => {
    const { token } = this.props.user;
    const item = await req_single_people(id, token);
    if (item != null) {
      this.setState({ CustodianTwName: item.TwName });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init = () => {
    if (this.props.space) {
      const item = this.props.space;
      this.setState({ item });
      this.setState({ CustodianTwName: item.CustodianTwName });
    }
  };

  // 操作互動處理 //////////////////////////////////////////////

  handleChange(event) {
    const { item } = this.state;
    Object.keys(item).forEach((propertyName) => {
      if (event.target.id === propertyName && event.target.value !== null) {
        item[propertyName] = event.target.value.trim();
        if (propertyName === "CustodianCode") {
          if (event.target.value.trim().length === 0) {
            this.setState({ CustodianTwName: "待定" });
          } else if (event.target.value.trim().length > 4) {
            this.api_single_item(event.target.value.trim());
            this.setState({ CustodianTwName: "查無此人" });
          }
        }
      }
    });
    this.setState({ item });
  }

  handleSelectedChange(value, field) {
    const { item } = this.state;
    Object.keys(item).forEach((propertyName) => {
      if (field === propertyName && value !== null) {
        item[propertyName] = value.trim();
      }
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const row = this.state.item;
    const errors = [];

    if (row.BuildingName === "NONE") {
      errors.push("未選擇所在建物");
    }
    if (row.DepartmentCode === "NONE") {
      errors.push("未選擇保管單位");
    }
    if (row.SpaceCode.trim().length === 0) {
      errors.push("未填空間編號");
    }
    if (row.CustodianTwName === "待定") {
      errors.push("職號格式錯誤");
    }
    if (row.CustodianTwName === "查無此人") {
      errors.push("查無此職號");
    }
    if (isNaN(parseFloat(row.SquareMeter))) {
      errors.push("平方公尺格式錯誤");
    }
    if (isNaN(parseInt(row.Accommodate))) {
      errors.push("容納人數格式錯誤");
    }

    if (errors.length === 0) {
      const { userCode } = this.props.user;
      row.LastChangeUserId = userCode;
      row.LastChangeStatus = "EDIT";
      row.RecordStatus = "ON";
      row.SquareMeter = parseFloat(row.SquareMeter);
      row.Accommodate = parseInt(row.Accommodate);
      row.condition = "BASE";
      //console.log(row);
      this.api_edit_item(row);
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  }

  handle_show_ui_modal = (type, item) => {
    //console.log(item);
    switch (type) {
      case "MANGER":
        this.setState({ isShowModal: true, item });
        break;
      default:
    }
  };

  //////////////////////////////////////////////////////////
  render() {
    const {
      BuildingName,
      SpaceCode,
      SpaceStandardTwName,
      SpaceStandardEnName,
      DepartmentCode,
      CustodianCode,
      SquareMeter,
      Accommodate,
      UseType,
      TvedbUseType,
      RecordDescription,
      ApplyPhysicalPlate,
      Monitoring,
      Floor,
    } = this.state.item;
    const { CustodianTwName, isShowModal, item } = this.state;
    return (
      <Card>
        <form onSubmit={this.handleSubmit}>
          <Tabs type="card">
            <Tabs.TabPane tab="基本資料" key="item-1">
              <div className="form-row">
                <div className="col-lg-8">
                  <div className="form-group">
                    <label>
                      <span
                        className="text-danger"
                        style={{ fontWeight: "bold", fontSize: "1em" }}
                      >
                        *
                      </span>
                      所在建物
                    </label>
                    <div>
                      <Select
                        defaultValue={BuildingName}
                        onChange={(value) =>
                          this.handleSelectedChange(value, "BuildingName")
                        }
                        style={{ width: "100%" }}
                      >
                        <Select.Option value="NONE">請選擇</Select.Option>
                        <Select.Option value="美術系館">
                          (A)美術系館
                        </Select.Option>
                        <Select.Option value="商學大樓">
                          (B)商學大樓
                        </Select.Option>
                        <Select.Option value="中正大樓">
                          (C)中正大樓
                        </Select.Option>
                        <Select.Option value="中央文創工廠">
                          (CC)中央文創工廠
                        </Select.Option>
                        <Select.Option value="設計大樓">
                          (D)設計大樓
                        </Select.Option>
                        <Select.Option value="教育大樓">
                          (E)教育大樓
                        </Select.Option>
                        <Select.Option value="服設館">(F)服設館</Select.Option>
                        <Select.Option value="家政館">(H)家政館</Select.Option>
                        <Select.Option value="幼教大樓">
                          (K)幼教大樓
                        </Select.Option>
                        <Select.Option value="圖書資訊大樓">
                          (L)圖書資訊大樓
                        </Select.Option>
                        <Select.Option value="生活科技大樓">
                          (LT)生活科技大樓
                        </Select.Option>
                        <Select.Option value="音樂館">(M)音樂館</Select.Option>
                        <Select.Option value="多功能展演中心">
                          (MF)多功能展演中心
                        </Select.Option>
                        <Select.Option value="乃建堂">(N)乃建堂</Select.Option>
                        <Select.Option value="學生活動中心">
                          (S)學生活動中心
                        </Select.Option>
                        <Select.Option value="教學大樓">
                          (T)教學大樓
                        </Select.Option>
                        <Select.Option value="育樂館">(Y)育樂館</Select.Option>
                        <Select.Option value="集賢盧">集賢盧</Select.Option>
                        <Select.Option value="馨如樓">馨如樓</Select.Option>
                        <Select.Option value="體育室">體育室</Select.Option>
                        <Select.Option value="貨櫃屋">貨櫃屋</Select.Option>
                        <Select.Option value="臨時教室">臨時教室</Select.Option>
                      </Select>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>樓層</label>
                    <div>
                      <Select
                        defaultValue={Floor}
                        onChange={(value) =>
                          this.handleSelectedChange(value, "Floor")
                        }
                        style={{ width: "100%" }}
                      >
                        <Select.Option value="10">10樓</Select.Option>
                        <Select.Option value="9">9樓</Select.Option>
                        <Select.Option value="8">8樓</Select.Option>
                        <Select.Option value="7">7樓</Select.Option>
                        <Select.Option value="6">6樓</Select.Option>
                        <Select.Option value="5">5樓</Select.Option>
                        <Select.Option value="4">4樓</Select.Option>
                        <Select.Option value="3">3樓</Select.Option>
                        <Select.Option value="2">2樓</Select.Option>
                        <Select.Option value="1">1樓</Select.Option>
                        <Select.Option value="0">平面</Select.Option>
                        <Select.Option value="B1">地下1樓</Select.Option>
                        <Select.Option value="B2">地下2樓</Select.Option>
                        <Select.Option value="B3">地下3樓</Select.Option>
                      </Select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>
                      <span
                        className="text-danger"
                        style={{ fontWeight: "bold", fontSize: "1em" }}
                      >
                        *
                      </span>
                      空間編號
                    </label>
                    <input
                      type="text"
                      className="form-control text-primary"
                      name="SpaceCode"
                      id="SpaceCode"
                      defaultValue={SpaceCode}
                      aria-describedby="mobileHelp"
                      placeholder="必填"
                      onChange={this.handleChange}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="col-lg-8">
                  <div className="form-group">
                    <label>
                      <span
                        className="text-danger"
                        style={{ fontWeight: "bold", fontSize: "1em" }}
                      >
                        *
                      </span>
                      空間中文名稱
                    </label>
                    <input
                      type="text"
                      className="form-control text-primary"
                      style={{ backgroundColor: "LightYellow" }}
                      name="SpaceStandardTwName"
                      id="SpaceStandardTwName"
                      defaultValue={SpaceStandardTwName}
                      aria-describedby="mobileHelp"
                      placeholder="必填"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="col-lg-8">
                  <div className="form-group">
                    <label>空間英文名稱</label>
                    <input
                      type="text"
                      className="form-control text-primary"
                      style={{ backgroundColor: "LightYellow" }}
                      name="SpaceStandardEnName"
                      id="SpaceStandardEnName"
                      defaultValue={SpaceStandardEnName}
                      aria-describedby="mobileHelp"
                      placeholder=""
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>申請新牌</label>
                    <Select
                      defaultValue={ApplyPhysicalPlate}
                      onChange={(value) =>
                        this.handleSelectedChange(value, "ApplyPhysicalPlate")
                      }
                      style={{ width: "100%" }}
                    >
                      <Select.Option value="N">
                        <div style={{ color: "blue" }}>不須更換</div>
                      </Select.Option>
                      <Select.Option value="Y">
                        <div style={{ color: "red" }}>更名抽換</div>
                      </Select.Option>
                    </Select>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="col-lg-6">
                  <label>平方公尺</label>
                  <input
                    type="text"
                    className="form-control text-primary"
                    style={{ backgroundColor: "LightYellow" }}
                    name="SquareMeter"
                    id="SquareMeter"
                    defaultValue={SquareMeter}
                    aria-describedby="mobileHelp"
                    placeholder="例：5.85"
                    onChange={this.handleChange}
                  />
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <label>容納人數</label>
                    <input
                      type="text"
                      className="form-control text-primary"
                      style={{ backgroundColor: "LightYellow" }}
                      name="Accommodate"
                      id="Accommodate"
                      defaultValue={Accommodate}
                      aria-describedby="mobileHelp"
                      placeholder="例：0"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="附加資訊" key="item-2">
              <div className="form-row">
                <div className="col-lg-7">
                  <div className="form-group">
                    <label>
                      <span
                        className="text-danger"
                        style={{ fontWeight: "bold", fontSize: "1em" }}
                      >
                        *
                      </span>
                      保管單位
                    </label>
                    <div>
                      <Select
                        defaultValue={DepartmentCode}
                        onChange={(value) =>
                          this.handleSelectedChange(value, "DepartmentCode")
                        }
                        style={{ width: "100%" }}
                      >
                        <Select.Option value="NONE">請選擇</Select.Option>
                        <Select.Option value="AA000">教務處</Select.Option>
                        <Select.Option value="AB000">學生事務處</Select.Option>
                        <Select.Option value="AC000">總務處</Select.Option>
                        <Select.Option value="AD000">研究發展處</Select.Option>
                        <Select.Option value="AE000">進修部</Select.Option>
                        <Select.Option value="AF000">
                          通識教育中心
                        </Select.Option>
                        <Select.Option value="AG000">
                          網路與資訊中心
                        </Select.Option>
                        <Select.Option value="AH000">圖書館</Select.Option>
                        <Select.Option value="AI000">人事室</Select.Option>
                        <Select.Option value="AJ000">會計室</Select.Option>
                        <Select.Option value="AK000">秘書室</Select.Option>
                        <Select.Option value="AM000">體育室</Select.Option>
                        <Select.Option value="AA100">
                          教學資源中心
                        </Select.Option>
                        <Select.Option value="CA000">
                          全球刺繡研究發展中心
                        </Select.Option>
                        <Select.Option value="CB000">
                          語文訓練中心
                        </Select.Option>
                        <Select.Option value="CC000">
                          文化創意設計研發中心
                        </Select.Option>
                        <Select.Option value="CD000">
                          校務研究中心
                        </Select.Option>
                        <Select.Option value="CE000">漢家幼兒園</Select.Option>
                        <Select.Option value="BA000">
                          生活科技學院
                        </Select.Option>
                        <Select.Option value="BA100">
                          美容造型設計系
                        </Select.Option>
                        <Select.Option value="BA200">餐飲系</Select.Option>
                        <Select.Option value="BA300">
                          運動休閒與健康管理系
                        </Select.Option>
                        <Select.Option value="BA400">
                          服飾設計管理系
                        </Select.Option>
                        <Select.Option value="BA500">幼兒保育系</Select.Option>
                        <Select.Option value="BA600">
                          生活服務產業系
                        </Select.Option>
                        <Select.Option value="BB000">管理學院</Select.Option>
                        <Select.Option value="BB100">財務金融系</Select.Option>
                        <Select.Option value="BB200">企業管理系</Select.Option>
                        <Select.Option value="BB300">
                          國際企業經營系
                        </Select.Option>
                        <Select.Option value="BB400">資訊管理系</Select.Option>
                        <Select.Option value="BB500">
                          連鎖加盟經營管理學士學位學程
                        </Select.Option>
                        <Select.Option value="BC000">設計學院</Select.Option>
                        <Select.Option value="BC100">
                          視覺傳達設計系
                        </Select.Option>
                        <Select.Option value="BC200">
                          多媒體動畫系
                        </Select.Option>
                        <Select.Option value="BC300">漫畫系</Select.Option>
                        <Select.Option value="BC400">室內設計系</Select.Option>
                        <Select.Option value="BC500">商品設計系</Select.Option>
                        <Select.Option value="BC600">時尚設計系</Select.Option>
                        <Select.Option value="BD000">藝術學院</Select.Option>
                        <Select.Option value="BD100">音樂系</Select.Option>
                        <Select.Option value="BD200">流行音樂系</Select.Option>
                        <Select.Option value="BD300">美術系</Select.Option>
                        <Select.Option value="BD400">舞蹈系</Select.Option>
                        <Select.Option value="BE000">旅遊學院</Select.Option>
                        <Select.Option value="BE100">旅館管理系</Select.Option>
                        <Select.Option value="BE200">
                          餐旅管理學士學位學程
                        </Select.Option>
                        <Select.Option value="BE300">應用英語系</Select.Option>
                        <Select.Option value="BE400">會計資訊系</Select.Option>
                        <Select.Option value="BE500">
                          養生休閒管理系
                        </Select.Option>
                        <Select.Option value="BF000">師培中心</Select.Option>
                      </Select>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="form-group">
                    <label>
                      <span
                        className="text-danger"
                        style={{ fontWeight: "bold", fontSize: "1em" }}
                      >
                        *
                      </span>
                      保管人職號(
                      <span style={{ color: "red" }}>{CustodianTwName}</span>)
                    </label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control text-primary"
                        style={{ backgroundColor: "LightYellow" }}
                        name="CustodianCode"
                        id="CustodianCode"
                        defaultValue={CustodianCode}
                        aria-describedby="mobileHelp"
                        placeholder="必填"
                        onChange={this.handleChange}
                        readOnly={true}
                      />
                      <div className="input-group-append">
                        <button
                          className="btn btn-success"
                          type="button"
                          onClick={() =>
                            this.handle_show_ui_modal("MANGER", item)
                          }
                        >
                          請選擇
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>用途別</label>
                    <div>
                      {" "}
                      <Select
                        defaultValue={UseType}
                        onChange={(value) =>
                          this.handleSelectedChange(value, "UseType")
                        }
                        style={{ width: "100%" }}
                      >
                        <Select.Option value="不分類">不分類</Select.Option>
                        <Select.Option value="普通教室">普通教室</Select.Option>
                        <Select.Option value="專業教室">專業教室</Select.Option>
                        <Select.Option value="研討室">研討室</Select.Option>
                        <Select.Option value="教師研究室">
                          教師研究室
                        </Select.Option>
                        <Select.Option value="研究生研究室">
                          研究生研究室
                        </Select.Option>
                        <Select.Option value="辦公室">辦公室</Select.Option>
                        <Select.Option value="會議室">會議室</Select.Option>
                        <Select.Option value="視聽教室">視聽教室</Select.Option>
                        <Select.Option value="閱覽室">閱覽室</Select.Option>
                        <Select.Option value="社團">社團</Select.Option>
                        <Select.Option value="電腦教室">電腦教室</Select.Option>
                        <Select.Option value="其他">其他</Select.Option>
                      </Select>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>校基庫分類</label>
                    <div>
                      <Select
                        defaultValue={TvedbUseType}
                        onChange={(value) =>
                          this.handleSelectedChange(value, "TvedbUseType")
                        }
                        style={{ width: "100%" }}
                      >
                        <Select.Option value="不列計">不列計</Select.Option>
                        <Select.Option value="普通教室">普通教室</Select.Option>
                        <Select.Option value="特別教室">特別教室</Select.Option>
                        <Select.Option value="實習工場及實驗室">
                          實習工場及實驗室
                        </Select.Option>
                        <Select.Option value="教師研究室">
                          教師研究室
                        </Select.Option>
                        <Select.Option value="學生研究室">
                          學生研究室
                        </Select.Option>
                        <Select.Option value="辦公室">辦公室</Select.Option>
                        <Select.Option value="會議室">會議室</Select.Option>
                        <Select.Option value="禮堂">禮堂</Select.Option>
                        <Select.Option value="圖書館">圖書館</Select.Option>
                        <Select.Option value="體育館含學生活動中心">
                          體育館含學生活動中心
                        </Select.Option>
                        <Select.Option value="餐廳">餐廳</Select.Option>
                        <Select.Option value="學生宿舍">學生宿舍</Select.Option>
                        <Select.Option value="單身教職員宿舍">
                          單身教職員宿舍
                        </Select.Option>
                        <Select.Option value="有眷教職員宿舍">
                          有眷教職員宿舍
                        </Select.Option>
                        <Select.Option value="其他">其他</Select.Option>
                      </Select>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label>使用狀況</label>
                    <Select
                      defaultValue={Monitoring}
                      onChange={(value) =>
                        this.handleSelectedChange(value, "Monitoring")
                      }
                      style={{ width: "100%" }}
                    >
                      <Select.Option value="N">
                        <div style={{ color: "red" }}>取消統計</div>
                      </Select.Option>
                      <Select.Option value="Y">
                        <div style={{ color: "green" }}>開啟統計</div>
                      </Select.Option>
                    </Select>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="col-lg-12">
                  <TextArea
                    rows={4}
                    placeholder="備註"
                    maxLength={100}
                    style={{ width: "100%", marginBottom: "4px" }}
                    onChange={this.handleChange}
                    defaultValue={RecordDescription}
                    name="RecordDescription"
                    id="RecordDescription"
                    showCount
                  />
                </div>
              </div>
            </Tabs.TabPane>
          </Tabs>
          <div className="form-row">
            <input
              type="submit"
              value="修改"
              className="btn btn-primary btn-sm btn-block"
            />
          </div>
        </form>
        <Modal
          destroyOnClose={true}
          visible={isShowModal}
          okText="關閉"
          onOk={() => {
            this.setState({ isShowModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SpaceManagementManagerModal space={item} />
        </Modal>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SpaceManagementModalEdit);
